<template lang="pug">
  .support-ctas(v-if="showSection" :class="{ column: direction === 'column' }")
    button.mr-btn.btn-secondary.xs-f-xxsmall.sm-f-xsmall.max-at-tweak(
      v-if="showChatCta"
      @click="openChat"
      :class="{ 'xs-mr-5': showPhoneCta }"
      data-mr-ass="support-chat-cta"
    )
      mr-icon(name="chat" height="3em" :fill="false")
      span send a message
 
    a.mr-btn.btn-secondary.xs-f-xxsmall.sm-f-xsmall.max-at-tweak(
      v-if="showPhoneCta"
      :href="`tel:${contactPhone}`"
      @click="doTrack('CC Call')"
      :class="{ 'xs-ml-5': showSection }"
      data-mr-ass="support-phone-cta"
    )
      mr-icon.phone-icon(name="phone-handset" height="3em" :fill="false")
      span Call ({{ contactPhone }})
</template>

<script>
  import { mapMutations } from 'vuex';
  import MrIcon from '@components/MrIcon';
  import sierraChatWidgetMixin from "@mixins/chatWidgetMixin/sierraChatWidgetMixin";

  export default {
    name: 'SupportCtas',

    components: {
      MrIcon,
    },

    mixins: [
      sierraChatWidgetMixin,
    ],

    props: {
      direction: {
        type: String,
        default: 'row',
      },
      hideCtas: {
        type: Array,
        default: () => [],
        required: false,
      },
      phoneNumber: {
        type: String,
        required: false,
        default: undefined,
      },
      trackEventParams: {
        type: Object,
        required: false,
        default: null,
      },
    },

    computed: {
      contactPhone() {
        return this.phoneNumber || this.$root.MRConfig.contactPhone;
      },

      showChatCta() {
        return !this.hideCtas.includes('chat');
      },

      showPhoneCta() {
        return !this.hideCtas.includes('phone');
      },

      showSection() {
        return this.showPhoneCta || this.showChatCta;
      },

      sierraExperiment() {
        return this.experiments?.sierraAiExperiment === "B";
      }

    },

    methods: {
      ...mapMutations('chatWidget', ['setDataForOpeningChat']),

      openChat(data) {
        if (this.sierraExperiment) {
          this.mix_doOpenChat();
        } else {
          this.setDataForOpeningChat(data);
        }
      },

      doTrack(name) {
        this.trackEvent(name, this.trackEventParams);
      },
    },
  };
</script>

<style scoped lang="stylus">
  .support-ctas
    max-width 100%
    display flex
    flex-direction row

    button, a
      padding 0.5em 2em
      width 100%
      white-space normal
      display flex
      flex-direction row
      align-items center
      justify-content space-between
      .phone-icon
        transform rotate(235deg)
    
  @media mq-tablet-plus
    .support-ctas.column
      flex-direction column
      a, button
        margin 5px 0 !important

  @media mq-desktop
    .support-ctas.column
      flex-direction column
      a, button
        margin 5px 0 !important

  @media mq-desktop-plus
    .support-ctas.column
      flex-direction column
      a, button
        margin 5px 0 !important
</style>